export const toHHMMSS = (sec_num: number) => {
  let hours: string | number = Math.floor(sec_num / 3600)
  let minutes: string | number = Math.floor((sec_num - hours * 3600) / 60)
  let seconds: string | number = sec_num - hours * 3600 - minutes * 60

  if (hours < 10) {
    hours = '0' + hours
  }
  if (minutes < 10) {
    minutes = '0' + minutes
  }
  if (seconds < 10) {
    seconds = '0' + seconds
  }
  return hours + ':' + minutes + ':' + seconds
}

export const toMMSS = (sec_num: number) => {
  let minutes: string | number = Math.floor(sec_num / 60)
  let seconds: string | number = sec_num % 60

  if (minutes < 10) {
    minutes = '0' + minutes
  }
  if (seconds < 10) {
    seconds = '0' + seconds
  }

  return minutes + ':' + seconds
}

export const toDays = (sec_num: number) => {
  return Math.floor(sec_num / 3600 / 24)
}

export const toMonths = (sec_num: number) => {
  return Math.floor(sec_num / 3600 / 24 / 30)
}

export const toYears = (sec_num: number) => {
  return Math.floor(sec_num / 3600 / 24 / 30 / 12)
}

export function formatDate(date: string) {
  const dateObj = new Date(date)
  const options = {
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  return dateObj.toLocaleString('en-GB', options)
}
